export const document_wrapper = typeof document !== "undefined" ? document : {};
export const navigator_wrapper = typeof navigator !== 'undefined' ? navigator : {}
